module.exports = __webpack_public_path__ + "static/img/webcache.36b6a76e.svg";